// Curated display fonts for page headlines. Keys match backend/fonts.py HEADLINE_FONTS exactly
// (also used as the Google Fonts family name for dynamic <link> loading).
export const HEADLINE_FONTS = [
  { id: "Outfit", label: "Outfit", googleParam: "Outfit:wght@800", vibe: "Clean & modern (default)" },
  { id: "Syne", label: "Syne", googleParam: "Syne:wght@800", vibe: "Bold & expressive (event default)" },
  { id: "Anton", label: "Anton", googleParam: "Anton", vibe: "Big & punchy" },
  { id: "Archivo Black", label: "Archivo Black", googleParam: "Archivo+Black", vibe: "Heavy & confident" },
  { id: "Bebas Neue", label: "Bebas Neue", googleParam: "Bebas+Neue", vibe: "Tall & condensed" },
  { id: "Oswald", label: "Oswald", googleParam: "Oswald:wght@700", vibe: "Narrow & sharp" },
  { id: "Space Grotesk", label: "Space Grotesk", googleParam: "Space+Grotesk:wght@700", vibe: "Geometric & techy" },
  { id: "Unbounded", label: "Unbounded", googleParam: "Unbounded:wght@800", vibe: "Rounded & playful" },
  { id: "Playfair Display", label: "Playfair Display", googleParam: "Playfair+Display:wght@800", vibe: "Elegant serif" },
  { id: "DM Serif Display", label: "DM Serif Display", googleParam: "DM+Serif+Display", vibe: "Classic serif" },
];

export function fontLabel(id) {
  return HEADLINE_FONTS.find((f) => f.id === id)?.label || id;
}
